<template>
  <div>
    <div />
  </div>
</template>

<script>
export default {
  name: 'VbManagement',
  components: {},
}
</script>
